"use strict";

exports.__esModule = true;
exports.getRoleName = getRoleName;
function getRoleName(roleId, roles) {
  var roleForId = roles.find(function (role) {
    return role.id === roleId;
  });
  return roleForId ? roleForId.name : "";
}